export default "__VITE_ASSET__B_H3$9K0__"